import PropTypes from 'prop-types';

const SlidingSelector = ({ selected, options, onChange }) => (
  <div className="flex max-w-max">
    {options.map((option, idx, arr) => (
      <button
        key={option}
        type="button"
        className={`border-2 border-pj-primary-300 px-10 py-2 font-semibold uppercase tracking-widest  ${
          selected === option && 'bg-pj-primary-400 text-pj-good-contrast'
        } ${idx === 0 && 'rounded-l-xl'} ${idx === arr.length - 1 && 'rounded-r-xl'}`}
        onClick={() => onChange(option)}
      >
        {option}
      </button>
    ))}
  </div>
);

SlidingSelector.propTypes = {
  selected: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SlidingSelector;
